import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Svg = styled.svg``;

const OuterCircle = styled.circle`
  fill: none;
  stroke: var(--cc_color_border_default);
`;

const ProgressCircle = styled.circle`
  fill: none;
  stroke: ${(props) => props.strokeColor};
  stroke-linecap: square;
  stroke-linejoin: square;
  stroke-dasharray: ${(props) => props.dashArray};
  stroke-dashoffset: ${(props) => props.dashOffset};
`;

/**
 * @deprecated Use { ProgressCircle } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/progresscircle--docs
 */

const CircularProgressBar = ({
  sqSize,
  percentage,
  strokeWidth,
  strokeColor,
}) => {
  const viewBox = `0 0 ${sqSize} ${sqSize}`;
  const radius = (sqSize - strokeWidth) / 2;
  const dashArray = radius * Math.PI * 2;
  const dashOffset = dashArray - (dashArray * percentage) / 100;

  return (
    <Svg width={sqSize} height={sqSize} viewBox={viewBox}>
      <OuterCircle
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
      />
      <ProgressCircle
        dashOffset={dashOffset}
        dashArray={dashArray}
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        strokeColor={strokeColor}
        transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
      />
    </Svg>
  );
};

CircularProgressBar.propTypes = {
  sqSize: PropTypes.string,
  percentage: PropTypes.number,
  strokeWidth: PropTypes.string,
  strokeColor: PropTypes.string,
};

CircularProgressBar.defaultProps = {
  strokeColor: 'var(--cc_color_text_default)',
};

export default CircularProgressBar;
